// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"276":"18d7a4a3","398":"41a4fa0c"}[chunkId] + ".chunk.js";
};